import { JsonRestApiRequestConfig, makeJsonRestApiRequest } from '~src/httpClient/RestApiService';
import { IResult } from '~src/httpClient/serverApi/types/IResponse';


export function removeFromIdentityPoolRequestConfig(systemUserId: string, poolId: string): JsonRestApiRequestConfig {
  return {
    restApiVersion: '3.18',
    httpMethod: 'DELETE',
    endpoint: `users/${systemUserId}/identityPool/${poolId}`,
    serverWideRequest: true
  };
}

export function callRemoveFromIdentityPoolRequest(systemUserId: string, poolId: string): Promise<IResult> {
  return makeJsonRestApiRequest<void, IResult>({
    config: removeFromIdentityPoolRequestConfig(systemUserId, poolId),
    request: null
  });
}
